import { TableBody } from "@mui/material";
import React, { useEffect, useCallback, useState } from "react";
import { useFormContext } from "react-hook-form";
import { useGetLaborDataByRouteId } from "../../hooks";

import LaborTableRow from "./LaborTableRow";

const LaborTableBody = ({
  routeId,
  enabled = true,
  setDeletingId = () => {},
  showHeatCode = false,
  showContextMenuColumn = true,
  scannedEmployee,
  canEditLabor,
}) => {
  const { data } = useGetLaborDataByRouteId(enabled && routeId);
  const { setValue, getValues } = useFormContext();
  const [fields, setFields] = useState([]);

  useEffect(() => {
    if (data) setFields(data);
  }, [data]);

  const onFieldUpdate = useCallback(
    (prefix) => {
      const item = getValues(prefix);

      if (!item?.laborId) return;

      const updatedLabor = getValues("updatedLabor") || [];
      const updatedIndex = updatedLabor.findIndex(
        (u) => u.laborId === item.laborId
      );

      if (updatedIndex > -1) updatedLabor[updatedIndex] = item;
      else updatedLabor.push(item);

      setValue("updatedLabor", updatedLabor);
    },
    [setValue, getValues]
  );

  return (
    <TableBody>
      {fields?.map((labor) => {
        const prefix = `labor.${labor.laborId}`;
        
        // Permission logic handled in canEditLabor function (accounts for admin/owner roles)
        const canEdit = canEditLabor ? canEditLabor(labor.userId) : false;
        const isDisabled = !canEdit;
        
        return (
          <LaborTableRow
            key={labor.laborId}
            prefix={prefix}
            labor={labor}
            onFieldUpdate={onFieldUpdate}
            setDeletingId={setDeletingId}
            showHeatCode={showHeatCode}
            showContextMenuColumn={showContextMenuColumn}
            disabled={isDisabled}
            scannedEmployee={scannedEmployee}
          />
        );
      })}
    </TableBody>
  );
};

export default React.memo(LaborTableBody);
